import React from "react";

import { sortBy } from "lodash";

import { SelectField } from "components/Form/FormikControls";

interface OutputFormatFieldProps {
  options: string[];
}

export const OutputFormatField = ({
  options,
}: OutputFormatFieldProps): React.JSX.Element => (
  <SelectField
    label="Output Format"
    name="outputFormat"
    options={sortBy(
      options.map(option => ({
        label: option.toUpperCase(),
        value: option,
      })),
      "label",
    )}
  />
);
